// extracted by mini-css-extract-plugin
export default {"FooterWrapper":"DrawerFooter_FooterWrapper__UwqwT","RightBox":"DrawerFooter_RightBox__2bTEo"};